import { Stack, useLocalSearchParams, useRouter } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import ErrorScreen, {
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';

type Params = {
  title: string;
  message: string;
  resultType: string;
  cardType: string;
  cardId?: string;
};

const CardActivationErrorScreen = () => {
  const router = useRouter();
  const { t: translatedText } = useTranslation('myVaro', {
    keyPrefix: 'activationCard',
  });

  const { title, message, cardType, cardId } = useLocalSearchParams<Params>();

  useViewDidFocusScreenAnalyticsEvent({
    key: cardId ? 'pinSetFailed' : 'Card Not On File',
    customAttributes: {
      card_type: cardType?.toLowerCase(),
    },
  });

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          headerShown: false,
        }}
      />
      <ErrorScreen
        screenType={title ? ErrorScreenType.Warning : ErrorScreenType.Error}
        messageHeadline={title || translatedText('errorTitle')}
        messageBody={message || translatedText('errorMessage')}
        primaryButton={{
          title: translatedText('done'),
          onPress: () => {
            if (router.canGoBack()) {
              router.back();
            } else {
              router.replace('/');
            }
          },
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

export default CardActivationErrorScreen;
